module.exports = __webpack_public_path__ + "img/copySolid.2e42cf48.svg";